import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";

export interface ActionItem {
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
  href?: string;
  variant?: "default" | "destructive";
}

interface ActionMenuProps {
  label?: string;
  actions: ActionItem[];
  align?: "start" | "end" | "center";
}

export function ActionMenu({ 
  label = "Actions",
  actions = [],
  align = "end" 
}: ActionMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Actions</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align}>
        <DropdownMenuLabel>{label}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        {actions?.map((action, index) => (
          <DropdownMenuItem
            key={index}
            className={action.variant === "destructive" ? "text-destructive" : ""}
            onClick={action.onClick}
            asChild={!!action.href}
          >
            {action.href ? (
              <Link to={action.href} className="flex items-center">
                {action.icon && <span className="mr-2">{action.icon}</span>}
                {action.label}
              </Link>
            ) : (
              <div className="flex items-center">
                {action.icon && <span className="mr-2">{action.icon}</span>}
                {action.label}
              </div>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}